import { render, staticRenderFns } from "./occupancyRatio.vue?vue&type=template&id=3e4e18d6"
import script from "./occupancyRatio.vue?vue&type=script&lang=js"
export * from "./occupancyRatio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports